import React from "react";
import { Modal, Button } from "react-bootstrap";
import { IoIosCheckmarkCircle, IoIosCloseCircle, IoIosWarning } from "react-icons/io";

class AlertModal extends React.Component {
  render() {
    const { show, title, message, type, onClose } = this.props;
    
    const getIcon = () => {
      switch (type) {
        case 'success':
          return <IoIosCheckmarkCircle size={50} color="#28a745" />;
        case 'error':
          return <IoIosCloseCircle size={50} color="#dc3545" />;
        case 'warning':
          return <IoIosWarning size={50} color="#ffc107" />;
        default:
          return <IoIosWarning size={50} color="#17a2b8" />;
      }
    };

    const getTitle = () => {
      if (title) return title;
      switch (type) {
        case 'success':
          return 'Éxito';
        case 'error':
          return 'Error';
        case 'warning':
          return 'Advertencia';
        default:
          return 'Información';
      }
    };

    return (
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{getTitle()}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="mb-3">
            {getIcon()}
          </div>
          <p>{message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={onClose}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default AlertModal;
